import uuid from 'uuid';

export const initialDesignId = uuid.v4();
